import { forwardRef } from 'react';

import { AlertSeverity } from '../../models';

import { SeverityIndicatorStyled } from './SeverityIndicator.styles';

export interface SeverityIndicatorProps {
  severity?: AlertSeverity;
  height?: number;
}

export const SeverityIndicator = forwardRef<HTMLDivElement, SeverityIndicatorProps>(function SeverityIndicator(
  { severity, height = 24, ...props },
  ref,
) {
  return (
    <SeverityIndicatorStyled
      role="presentation"
      aria-label="severity indicator"
      ref={ref}
      severity={severity}
      height={height}
      {...props}
    />
  );
});
